<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Perfil del comercio</h1></div>
    </div>

    <div class="">
        <div class="imgPerfil" [style.background-image]="preview_img_avatar ? 'url(' + preview_img_avatar + ')' : 'url(./assets/img/perfil-comercio-n.png)'"> </div>
        <div class="row-cols-12 background-white">
            <div class="text-p p-3 pt-2 pb-0" style="font-weight: bold; font-size: 1.3em;">
                <hr style="width:20%;height: 5px;color: #CDCFD0;border-radius: 10px;margin: 0 auto;">
            </div>  
        </div>
        <!-- <div class="chkPerfil fade-in">
            <div class="">
                <i class="bi bi-star" style="color: #205EA5;float:right;"></i> <i class="bi bi-star" style="color: #205EA5;float:right;"></i> <i class="bi bi-star" style="color: #205EA5;float:right;"></i>
            </div>
        </div> -->
    </div>
    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
        <div class="row mt-0">
            <div class="col">
                <div class="text-p p-3 pb-1 pt-0 nameUser">
                    {{nombre}}
                </div>
            </div>
            <div class="col-auto pt-2">
                <i class="bi bi-star bistarnf" style="color: #205EA5;float:right;"></i> <i class="bi bi-star bistarnf" style="color: #205EA5;float:right;"></i> <i class="bi bi-star-fill bistar" style="color: #205EA5;float:right;"></i> <i class="bi bi-star-fill bistar" style="color: #205EA5;float:right;"></i> <i class="bi bi-star-fill bistar" style="color: #000;float:right;"></i>
            </div>
        </div>
        
        <!-- <hr class="divisor mt-0 mb-1"> -->

        <div class="row-cols-12 mt-0">
            <div class="row p-3 pb-0">
                <div class="col-auto text-start fieldName">
                    <i class="bi bi-geo-alt"></i>
                </div>
                <div class="col col-lg-10  fieldInfo text-start">
                    <div class="col fw-bold" style="font-size: 0.9em;">
                        Ubicaciones:
                    </div>
                    @for(ubicacion of ubicaciones; track ubicacion.id){
                        <div class="col" style="font-size: 0.8em;">
                            {{ubicacion.x_domicilio}}. {{ubicacion.x_piso_dpto}} - {{ubicacion.x_codigo_postal}}
                        </div>
                    }
                </div>
            </div>
            <div class="row p-3 pb-0">
                <div class="col-auto text-start fieldName">
                    <i class="bi bi-clipboard2"></i>
                </div>
                <div class="row col col-lg-10  fieldInfo text-start d-flex align-items-start ">
                    <div class="col-auto fw-bold" style="font-size: 0.9em;">
                        Opciones aceptadas:
                    </div>
                    <div class="row col-5" style="font-size: 0.8em;">
                        @if(b_envio_domicilio){
                            <span class="col-4 pe-3 d-flex align-items-center"><i class="bi bi-truck icons-detail pe-1"></i> </span>
                        }
                        <span class="col-4 pe-3 d-flex align-items-center"><i class="bi bi-shop icons-detail pe-1"></i> </span>
                        @if(b_pago_mercadopago){
                            <span class="col-4 pe-1"><img src="./assets/img/mercado_pago.png" title="Mercado Pago" class="icon-mercadopago pe-1" style="width:20px;"> </span>
                        }
                    </div>
                </div>
            </div>
            <div class="row p-3 pb-0">
                <div class="col-auto text-start fieldName">
                    <i class="bi bi-clock"></i>
                </div>
                <div class="col col-lg-10  fieldInfo text-start text-truncate">
                    <div class="col fw-bold" style="font-size: 0.9em;">
                        Horarios:
                    </div>
                    @if (!horario) {
                        <div class="col" style="font-size: 0.8em;">
                            Sin horarios cargados.
                        </div>
                    } @else {
                        <div class="col" style="font-size: 0.8em;">
                            Lun. {{ horario.x_lunes_desde ?? '' }} - {{ horario.x_lunes_hasta ?? '' }}<br/>
                            Mar. {{ horario.x_martes_desde ?? '' }} - {{ horario.x_martes_hasta ?? '' }}<br/>
                            Mié. {{ horario.x_miercoles_desde ?? '' }} - {{ horario.x_miercoles_hasta ?? '' }}<br/>
                            Jue. {{ horario.x_jueves_desde ?? '' }} - {{ horario.x_jueves_hasta ?? '' }}<br/>
                            Vie. {{ horario.x_viernes_desde ?? '' }} - {{ horario.x_viernes_hasta ?? '' }}<br/>
                            Sáb. {{ horario.x_sabado_desde ?? '' }} - {{ horario.x_sabado_hasta ?? '' }}<br/>
                            Dom. {{ horario.x_domingo_desde ?? '' }} - {{ horario.x_domingo_hasta ?? '' }}
                        </div>
                    }
                </div>
            </div>
        </div>
        <!-- <hr class="divisor mt-3 mb-1"> -->
    </div>

    <div class="d-grid mt-0 mb-3 pb-3 align-items-center">
        <button type="submit" class="btn btn-primary btn-lg mt-4" [routerLink]="['/comercio']">Realizar un pedido</button>
    </div>
</div>